export enum FieldSettingValues {
    Record = 'Record',
    Model = 'Model',
    HasOne = 'HasOne',
    HasMany = 'HasMany',
    FieldMapping = 'FieldMapping'
}
